import { connect } from 'react-redux';
import Actions from '../actions';
import ZoneSelectModal from '../components/zone/zone-select-modal';
import APP_DEFAULTS from '../constants/app-defaults';

const distinctProducts = (products) => {
    const productsFilters = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const product of products) {
        const filterCondition = productsFilters.findIndex((item) => item.id === product.id) === -1;
        if (filterCondition) {
            productsFilters.push(product);
        }
    }
    return productsFilters;
};

const fetchProducts = (dispatch, locale) => dispatch(Actions.fetchProducts({ page_no: 1, locale })).then((response) => {
    const fetchedProducts = response.body;
    dispatch(Actions.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
    dispatch(Actions.hideLoader());
});

const mapStateToProps = (state, ownProps) => ({
    availableZones: state.zones.availableZones,
    currentZone: state.zones.availableZones,
    availableMunicipalities: state.municipalities.availableMunicipalities,
});

const mapDispatchToProps = (dispatch) => ({
    setUserSelection: (zoneId, municipalityId) => {
        dispatch(Actions.setCurrentMunicipality(municipalityId));
        dispatch(Actions.setCurrentZone(zoneId));
        dispatch(Actions.displayLoader());
        fetchProducts(dispatch);
    },
});

const ZoneSelectConnector = connect(mapStateToProps, mapDispatchToProps)(ZoneSelectModal);

export default ZoneSelectConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/zone-select-connector.js
 **/